require('./navigation/anchor');
require('./navigation/feature');
require('./decklist/decklist');
require('./strategy/strategy');
require('./analysis/analysis');
require('./user/identity');
require('./help/help');
const Deck = require('./decklist/deck');
const API = require('../services');
const UserDecks = require('./decklist/userdecks');
const DeckStore = require('./user/deck-store'); 
const Commons = require('./commons/commons');
const Cards = require('./commons/cards-search');
const CardService = API.Cards;
const CardDetail = require('./ui/card-detail').default;
const CommonsStore = API.Commons;
const Tracker = require('./navigation/tracker');
const Route = require('./navigation/route');
const router = require('./navigation/router');
const uievents = require('./ui/events');
const template = require('./index.tpl').default;

require('./index.css');

export default DomClass(template, function() {
	var _t = this;

	var tracker = new Tracker();
	tracker.trackPageview();

	if (this.favicon) {
		var link = document.createElement('link');
		link.rel = 'shortcut icon';
		link.href = this.favicon;
		document.getElementsByTagName('head')[0].appendChild(link);
	}

	var canonicalUrl = document.createElement('link');
	canonicalUrl.rel = 'canonical';
	canonicalUrl.href = document.location;
	document.getElementsByTagName('head')[0].append(canonicalUrl);

	document.title = this.name || "MTG Deck Analyzer";

	var show = function(page, title) {
		[_t.decks, _t.shared, _t.cards, _t.help].forEach(function(f) {
			f.deselect();
		});

		document.title = Array.isArray(title) ? (
			['MTG Deck Analyzer', ...title].join(' - ')
		) : title || "MTG Deck Analyzer";

		if (page) {
			_t.page = page;
			_t.pageContainer.classList.add('visible');
		} else {
			_t.page = '';
			_t.pageContainer.classList.remove('visible');
		}
	};

	// TODO: Should `open()` be a property of a Deck object? (or any "navigable" object?)
	var openDeck = function(collection, id, tab) {
		var store = {
			decks: DeckStore,
			shared: CommonsStore
		}[collection];

		/**
		 * hackish, but we're re-calling openDeck() on auth changes. but,
		 * we don't want to perform a full reload if the deck hasn't changed
		 * and the use still has permissions. so, if the path is the same,
		 * we'll leave the deck in place, check for access behind the scenes,
		 * and THEN navigate back to the index if the user doesn't have access
		 * (or if the deck can't be loaded for any other reason).
		 */
		if (_t.page.$id == id && _t.page.collection == collection) {
			_t.page[tab || 'strategy-tab'].select();
			store.get(id).then(deck => {
				if (!deck) {
					router.navigate('?decks', {}, true);
				}
			});
			return;
		}

		show('loading ...');

		store.get(id).then(function(deck) {
			if (deck) {
				deck.collection = collection;
				deck = new Deck(deck);
				if (store.autoSave) {
					store.autoSave(deck);
				} else {
					deck.lock();
				}
				show(deck, ['Decks', deck.name]);
				deck[tab || 'strategy-tab'].select();
			} else {
				router.navigate('?decks', {}, true);
			}
		});
	};

	var openCard = function(cardName) {
		CardService.get(cardName).then(function(card) {
			show(new CardDetail(card), ['Cards', cardName]);
		});
	};

	var route = new Route([
		/^(decks|shared)\/([^\/]+)\/?([^\/]+)?$/, function(collection, id, tab) {
			openDeck(collection, id, tab);
		},
		/^cards$/, function() {
			route.open('cards/~//gt/');
		},
		/^cards\/~\/([^\/]*)(\/gt\/([^\/]*))?$/, function(query, nothing, after) {
			// clear while we wait for load.
			show(null);
			query = decodeURIComponent(query);
			after = decodeURIComponent(after || '');
			_t.cards.select();
			_t.cards.content.search(query, after, true);
		},
		/^cards\/([^\/]+)$/, function(cardName) {
			openCard(decodeURIComponent(cardName));
		},
		/^(decks|help)$/, function(feature) {
			show(null);
			_t[feature].select();
		},
		/^shared$/, function() {
			route.open('shared/~//gt/');
		},
		/^shared\/~\/([^\/]*)(\/gt\/([^\/]*))?$/, function(query, nothing, after) {
			// clear while we wait for load.
			show(null);
			query = decodeURIComponent(query);
			after = decodeURIComponent(after);
			_t.shared.select();
			_t.shared.content.search(query, after, true);
		},
		/^pages\/(.+)$/, function(page) {
			// routing all pages through here for now. eventually pages should be
			// independant of the deck analyzer SPA portions. but, that may force
			// us to tackle some authenticator changes. maybe ... we'll see.
			show('Loading ...');
			fetch(`/pages/${page}`).then(r => {
				r.text().then(html => {
					const parser = new DOMParser();
					const dom = parser.parseFromString(html, 'text/html');
					document.title = dom.title;
					show(dom.body.innerHTML);
				});
			});
		},
		/.*/, function() {
			route.open('decks');
		}
	]);

	on(route, 'change').then(function() {
		canonicalUrl.href = document.location;
	});

	on(DeckStore, 'change').then(function(evt) {
		route.reload();
	});

	// TODO: these features heads should eventually just be anchors.
	[this.decks, this.shared, this.help].forEach(function(feature) {
		on(feature, 'select').then(function() {
			route.open(feature['data-id']);
		})
	});

	router.navigate(null, true);

});

